module.exports = __webpack_public_path__ + "img/th_th.30c96f09.png";